import React, { useEffect, useRef, useState } from "react";
import { TextField } from "@mui/material";

/**
 * Self-contained search box that keeps the raw input value in local state and
 * only notifies the parent with the debounced value. This isolates keystrokes
 * from the (potentially large) assessment list rendered by the parent, so the
 * list is not reconciled on every character typed.
 */
function HistorySearchField({ placeholder, onDebouncedChange, delay = 300 }) {
  const [value, setValue] = useState("");
  const timeoutRef = useRef(null);

  useEffect(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    timeoutRef.current = setTimeout(() => {
      onDebouncedChange(value);
    }, delay);

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [value, delay, onDebouncedChange]);

  return (
    <TextField
      fullWidth
      size="small"
      placeholder={placeholder}
      value={value}
      onChange={(event) => setValue(event.target.value)}
    />
  );
}

export default HistorySearchField;
